
import { types, actions } from './requests'
export const CREATEFAMILY_TYPES = {
    ...types('CREATEFAMILY'),
}
export const CREATEFAMILY_ACTIONS = {
    ...actions('CREATEFAMILY'),
}